import { useState } from 'react';
// @mui
import { Button, Menu, MenuItem, Checkbox, ListItemText } from '@mui/material';
// components
import Iconify from '../Iconify';
import { ColumnDef } from '../../hooks/useColumnVisibility';

// ----------------------------------------------------------------------
// Shared "Columns" control: a button + checkbox menu to show/hide table
// columns. Pairs with the useColumnVisibility hook.

type Props = {
  columns: ColumnDef[];
  visibleColumns: string[];
  onToggle: (id: string) => void;
  label?: string;
};

export default function ColumnsButton({
  columns,
  visibleColumns,
  onToggle,
  label = 'Columns',
}: Props) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  return (
    <>
      <Button
        size="small"
        color="inherit"
        variant="outlined"
        onClick={(e) => setAnchor(e.currentTarget)}
        startIcon={<Iconify icon="eva:grid-outline" />}
      >
        {label}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {columns.map((c) => (
          <MenuItem key={c.id} onClick={() => onToggle(c.id)} dense>
            <Checkbox
              checked={visibleColumns.includes(c.id)}
              size="small"
              sx={{ p: 0.5, mr: 1 }}
            />
            <ListItemText primary={c.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
